import {useState, useEffect} from "react"
import { Outlet } from "react-router-dom"

import Header from "./Header";
import Footer from "./Footer"


export default function Layout() {
    
    const [darkMode, setDarkMode] = useState(false);

    function switchColorScheme() {
        setDarkMode((set) => !set)
        localStorage.setItem("dark-mode", !darkMode);
    }

    useEffect(()=>{
        const currentColorScheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? true : false;
        const localStorageMode = window.localStorage.getItem('dark-mode')

        if (localStorageMode) {
            setDarkMode(JSON.parse(localStorageMode))
        } else {
            setDarkMode(currentColorScheme)
        }
    },[])



    return(
        <div className={`site-wrapper ${darkMode ? "dark" : "light"}`}>
            <Header 
                switchColorScheme={switchColorScheme} 
                darkMode={darkMode}
                setDarkMode={setDarkMode}    
            />
            <main>
                <Outlet />
            </main>
            <Footer />
            
        </div>
    )
}